// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { BaseSettings } from '@shared/commons/Settings/BaseGeneralSettingsWrapper';
import { PriceFormatter } from '../Instruments/PriceFormatter';
import { MathUtils } from '../MathUtils';
import { StringUtils } from '../StringUtils';
class _VolumeFormatter {
    getVolumeFormat(volume, isForceAbbreviateVolumes = false, emptyStr = '') {
        if (volume === null || isNaN(volume)) {
            if (!isValidString(emptyStr)) {
                return StringUtils.NOT_AVAILABLE;
            }
            else {
                return emptyStr;
            }
        }
        const defaultPrecision = 2;
        if (BaseSettings.abbreviateVolumes || isForceAbbreviateVolumes) {
            let abbreviate = '';
            if (Math.abs(volume) >= 1000000000000) {
                volume /= 1000000000000;
                abbreviate = 'T';
            }
            else if (Math.abs(volume) >= 1000000000) {
                volume /= 1000000000;
                abbreviate = 'B';
            }
            else if (Math.abs(volume) >= 1000000) {
                volume /= 1000000;
                abbreviate = 'M';
            }
            else if (Math.abs(volume) >= 1000) {
                volume /= 1000;
                abbreviate = 'K';
            }
            if (abbreviate !== '') {
                return `${MathUtils.TruncateDouble(volume, defaultPrecision)}${abbreviate}`;
            }
        }
        return PriceFormatter.formatPriceWithoutZeroes(volume, defaultPrecision);
    }
}
export const VolumeFormatter = new _VolumeFormatter();
